import React from 'react';
import { motion } from 'framer-motion';
import { InteriorSlide, SlideBanner } from './SlideShell';
import type { SlideProps } from './SlideShell';
import { jascaydSteps } from '../../data/jascaydOffer';
export function SlideJascaydJourney({}: SlideProps) {
  return <InteriorSlide surface banner={<SlideBanner data-id="element-320" data-mp="no4gepgsjal4">
          Earn attention with something short — then offer the deeper dive.
        </SlideBanner>} data-id="element-319" data-mp="iujfopntc2i8">
      <motion.header initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="flex-shrink-0" data-id="element-321" data-mp="soa2zr87e6wc">
        <p className="mb-2 text-[clamp(0.7rem,1vw,0.9rem)] font-bold uppercase tracking-[0.2em] text-[var(--brand)]" data-id="element-322" data-mp="12kv9yi3s9s2t">
          How the campaign runs
        </p>
        <h2 className="max-w-5xl text-[clamp(1.9rem,3.6vw,3.3rem)] font-extrabold leading-[1.02] tracking-[-0.04em] text-[var(--fg)]" data-id="element-323" data-mp="34c89ssqw99s0">
          Five steps from pilot{' '}
          <span className="text-[var(--brand)]" data-id="element-324" data-mp="24i24p3ikimzt">to proven campaign.</span>
        </h2>
      </motion.header>

      {/* Journey strip: teaser → follow-up */}
      <motion.div initial={{
      opacity: 0,
      y: 14
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.15,
      duration: 0.45
    }} className="mt-[clamp(0.9rem,1.8vw,1.5rem)] flex flex-shrink-0 flex-wrap items-center gap-[clamp(0.4rem,0.8vw,0.7rem)]" data-id="element-325" data-mp="1zqk5ajw70ugy">
        {['Short Snak', 'Quiz / poll', 'Deeper follow-up', 'Insight'].map((label, i, arr) => <React.Fragment key={label} data-id="element-326" data-mp="2ij4rxjlau3cb" data-mpi={i}>
              <span className={`rounded-full px-[clamp(0.75rem,1.2vw,1.1rem)] py-[clamp(0.35rem,0.6vw,0.5rem)] text-[clamp(0.75rem,1vw,0.95rem)] font-bold ${i === 0 ? 'bg-[var(--brand)] text-white' : 'bg-white text-[var(--fg)] ring-1 ring-[var(--fg)]/5'}`} data-id="element-327" data-mp="2ifz5kc421fka">
                {label}
              </span>
              {i < arr.length - 1 && <span className="h-px w-[clamp(1rem,2vw,2rem)] bg-[var(--brand)]/40" aria-hidden="true" data-id="element-328" data-mp="3lbgzf39hqm61" />}
            </React.Fragment>)}
      </motion.div>

      <ol className="mt-[clamp(0.9rem,1.8vw,1.5rem)] grid min-h-0 flex-1 grid-cols-1 gap-[clamp(0.5rem,1vw,0.9rem)] md:grid-cols-5" data-id="element-329" data-mp="3bd1czdles12v">
        {jascaydSteps.map((step, index) => <motion.li key={step.number} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.22 + index * 0.08,
        duration: 0.45
      }} className="relative flex min-h-0 flex-col rounded-2xl bg-white p-[clamp(0.9rem,1.6vw,1.5rem)] shadow-sm ring-1 ring-[var(--fg)]/5" data-id="element-330" data-mp="31lwva64cm24c" data-mpi={index}>
            <span className="text-[clamp(1.6rem,2.8vw,2.6rem)] font-extrabold leading-none tracking-[-0.04em] text-[var(--brand)]" data-id="element-331" data-mp="2xiqu3cw3f14q">
              {step.number}
            </span>
            <h3 className="mt-[clamp(0.6rem,1.1vw,1rem)] text-[clamp(1rem,1.45vw,1.35rem)] font-extrabold leading-tight tracking-[-0.02em] text-[var(--fg)]" data-id="element-332" data-mp="2nm5oapc91lzu">
              {step.title}
            </h3>
            <p className="mt-[clamp(0.35rem,0.7vw,0.6rem)] text-[clamp(0.75rem,1vw,0.95rem)] leading-snug text-[var(--muted)]" data-id="element-333" data-mp="2013bby2eputb">
              {step.text}
            </p>
          </motion.li>)}
      </ol>
    </InteriorSlide>;
}